import { SET_USER_DATA, SET_USER_LIST, SET_USER_PAGINATION } from "../ActionName/ActionName"

export const setUserData= (data) => {
    return {
        type:SET_USER_DATA ,
        value: data
    }
}

export const setUserList = (data) => {
    return {
        type: SET_USER_LIST,
        value: data
    }
}

export const setUserPagination = (data) => {
    return {
        type: SET_USER_PAGINATION,
        value: data
    }
}




